import React from 'react';

const fmt = (value) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value ?? 0);

const HIDDEN = '••••••';

const CARDS = [
    {
        key: 'bank_balance',
        label: 'Saldo em Bancos',
        icon: '🏦',
        color: '#0ea5e9',
        getValue: (kpi) => fmt(kpi.bank_balance),
        getSub: () => 'contas ativas',
        alert: false,
    },
    {
        key: 'receivable',
        label: 'A Receber',
        icon: '📥',
        color: '#10b981',
        getValue: (kpi) => fmt(kpi.receivable),
        getSub: (kpi) => `${kpi.receivable_count} lançamento${kpi.receivable_count !== 1 ? 's' : ''}`,
        alert: false,
    },
    {
        key: 'payable',
        label: 'A Pagar',
        icon: '📤',
        color: '#f59e0b',
        getValue: (kpi) => fmt(kpi.payable),
        getSub: (kpi) => `${kpi.payable_count} lançamento${kpi.payable_count !== 1 ? 's' : ''}`,
        alert: false,
    },
    {
        key: 'overdue',
        label: 'Em Atraso',
        icon: '⚠️',
        color: '#ef4444',
        getValue: (kpi) => fmt(kpi.overdue),
        getSub: (kpi) => `${kpi.overdue_count} lançamento${kpi.overdue_count !== 1 ? 's' : ''}`,
        alert: true,
    },
    {
        key: 'available_credit',
        label: 'Crédito Disponível',
        icon: '💳',
        color: '#8b5cf6',
        getValue: (kpi) => fmt(kpi.available_credit),
        getSub: (kpi) => `de ${fmt(kpi.total_credit_limit)} de limite`,
        alert: false,
    },
];

function KpiCards({ data, hideValues }) {
    if (!data) return null;

    return (
        <div className="kpi-section">
            <div className="kpi-section__header">
                <span className="kpi-section__title">Posição Atual</span>
                <span className="kpi-section__badge">● tempo real</span>
            </div>
            <div className="kpi-cards-grid">
                {CARDS.map((card) => {
                    const isAlert = card.alert && data[card.key] > 0;
                    return (
                        <div
                            key={card.key}
                            className={`kpi-card${isAlert ? ' kpi-card--alert' : ''}`}
                            style={{ '--kpi-color': card.color }}
                        >
                            <div className="kpi-card__accent" />
                            <div className="kpi-card__body">
                                <span className="kpi-card__icon">{card.icon}</span>
                                <span className="kpi-card__label">{card.label}</span>
                                <span className="kpi-card__value">{hideValues ? HIDDEN : card.getValue(data)}</span>
                                <span className="kpi-card__sub">{hideValues ? '––' : card.getSub(data)}</span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default KpiCards;
